import styled from 'styled-components';
import {
  VCustomDateTimePicker,
  VDateRangePicker,
  VDateTimePicker,
  VInputField,
  VTagInputField
} from 'welltrax-ui-components';
import { IInputFieldProps } from 'welltrax-ui-components/lib/types/Form/Inputs/DateTimePicker';
import { Divider } from '@blueprintjs/core';

interface IVSelectContainer {
  minimal?: boolean;
}

export const StyledModificator = styled.div`
  .ag-theme-balham .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
    border: none;
    outline: initial;
  }
  .gsi-color-picker .bp3-popover-target {
    display: flex;
  }
`;

export const StyledFilterField = styled.div`
  input {
    width: 180px !important;
  }
  .gsi-input-multi-select input {
    padding-right: 103px !important;
  }
  button {
    width: 180px !important;
  }

  .bp3-timepicker-input-row .bp3-timepicker-input {
    width: 52px !important;
  }

  .bp3-tag-input {
    width: 180px !important;
    button {
      width: 30px !important;
    }
  }
  .bp3-form-group {
    margin: 0;
  }

  .bp3-control-group .bp3-input-group input {
    width: 90px !important;
    padding: 6px !important;
  }
`;

interface IDIField {
  isStacked: boolean;
}

interface IStyledDateRangeField {
  isStacked?: boolean;
  refWidth?: number;
  onTable?: boolean;
}

export const StyledDateRangeField = styled(VDateRangePicker)`
  .bp3-input-group input {
    font-size: ${(props: IStyledDateRangeField) => {
      const width = props?.refWidth ?? 0;
      return width < 350 ? (width < 290 ? '12px' : '13px') : '14px';
    }};
  }

  .bp3-input-group .bp3-input {
    width: ${(props: IStyledDateRangeField) => props.isStacked && '100px'};
  }
`;

export const StyledCustomDateTimePicker = styled(VCustomDateTimePicker)`
  .bp3-input-group input {
    font-size: ${(props: IStyledDateRangeField) => {
      const width = props?.refWidth ?? 0;
      return width < 350 ? (width < 290 ? '10px' : '13px') : '14px';
    }};
    width: ${(props: IStyledDateRangeField) => props.onTable && '88px!important'};
  }
`;

export const StyledInputField = styled(VInputField)`
  .bp3-form-content .gsi-input-and-error-container .bp3-input-group input {
    width: ${(props: IDIField) => props.isStacked && '120px'};
  }
`;

export const StyledVTagInputField = styled(VTagInputField)`
  .bp3-form-content .gsi-form-field-container .gsi-input-and-error-container {
    width: ${(props: IDIField) => props.isStacked && '120px'};
  }
`;

export const BorderContainer = styled.div`
  border-radius: 3px;
  box-shadow: ${(props: IVSelectContainer) =>
    props.minimal && 'inset 0 0 0 1px rgba(16, 22, 26, 0.15), inset 0 1px 1px rgba(16, 22, 26, 0.2)'};
  .bp3-timepicker-input-row {
    width: ${(props: IVSelectContainer) => props.minimal && '100%'};
    display: ${(props: IVSelectContainer) => props.minimal && 'flex !important'};
  }
`;

interface IButtonGroupStyled {
  width: number;
  repeat: string;
}

export const ButtonGroupStyled = styled.div`
  display: grid;
  grid-template-columns: ${(props: IButtonGroupStyled) => props.repeat};
  grid-template-rows: repeat(2, fit-content);
  grid-gap: 3px;
  width: calc(100% - 5px);

  .buttons-group-filters {
    font-size: ${(props: IButtonGroupStyled) => (props.width <= 275 ? '10px' : 'auto')};
  }
`;

export const TagInputContainerWithTooltipStyled = styled.div`
  width: 100%;
  & .bp3-popover-target {
    width: 100%;
  }
`;

interface VDateTimePickerStyled extends IInputFieldProps {
  type?: 'filter' | 'conditional';
}

const isTimeAmPM = (props: VDateTimePickerStyled) => {
  return props.useAmPm && props.dateType === 'TIME';
};

export const VDateTimePickerStyled = styled(VDateTimePicker)`
  & .bp3-timepicker-input-row {
    width: ${(props: VDateTimePickerStyled) => isTimeAmPM(props) && 'initial'};
    display: ${(props: VDateTimePickerStyled) => isTimeAmPM(props) && 'inline-block !important'};

    & input.bp3-timepicker-hour,
    input.bp3-timepicker-minute {
      width: ${(props: VDateTimePickerStyled) => (isTimeAmPM(props) ? props?.type === 'conditional' && '24px' : '50%')};
    }
  }

  & .bp3-html-select.bp3-timepicker-ampm-select {
    margin-left: ${(props: VDateTimePickerStyled) => isTimeAmPM(props) && props?.type === 'conditional' && '2px'};
    & select {
      padding: ${(props: VDateTimePickerStyled) =>
        isTimeAmPM(props) && props?.type === 'conditional' && '0 20px 0 5px'};
    }
  }
`;

export const DividerStyle = styled(Divider)`
  margin: 10px 0 10px 0 !important;
`;
